var map = {
	"./PM_2.2.2.png": 8080,
	"./PM_2.3.2.png": 70670,
	"./PM_3.2.2.png": 22956,
	"components/Catalog/PM/img/glass/mt/mtPlusBlack/PM_2.2.2.png": 8080,
	"components/Catalog/PM/img/glass/mt/mtPlusBlack/PM_2.3.2.png": 70670,
	"components/Catalog/PM/img/glass/mt/mtPlusBlack/PM_3.2.2.png": 22956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90901;